import React, {Component} from 'react';
import '../assets/css/dashboard.css';
import config from '../config';
import {
	outAppointment,
	joinAppointment,
	reset,
} from "../redux/actions/register/appointment";
import {connect} from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class ClientVideoSession extends Component {
	constructor(props) {
		super(props);
		this.es = null;
		this.state = {
			appointment: '',
			listening: false,
		}
	}

	componentDidMount() {
		const {
			joinAppointment
		} = this.props;

		const data = {
			auth_id: localStorage.client_id,
			id: this.props.match.params && this.props.match.params.id,
			client_id: localStorage.client_id,
			role: 'client',
			start_session: true,
		};

		if(joinAppointment) {
			joinAppointment(data)
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if(this.props.msg_join && prevProps.msg_join !== this.props.msg_join) {
			toast(this.props.msg_join);
			const {
				reset
			} = this.props;
			clearTimeout(this.tmr);
			this.tmr = setTimeout(function () {
				reset();
				this.tmr = null;
			}, 2500);
		}
		if (this.props.msg_join_err && this.props.msg_join_err !== prevProps.msg_join_err) {
			toast(this.props.msg_join_err);
			let self = this;
			const {
				reset
			} = this.props;
			clearTimeout(this.tmr);
			this.tmr = setTimeout(function () {
				reset();
				this.tmr = null;
				self.props.history.push("/client-session/" + self.props.match.params.id);
			}, 2500);
		}
		if (this.props.msg_event !== prevProps.msg_event) {
			let self = this;
			let link = this.props.match.params && this.props.match.params.id;
			if(this.props.msg_event === false || this.props.msg_event === 'The meeting has already finished') {
				let str = this.props.msg_event === false? "Please wait for the provider until he will join again.": this.props.msg_event;
				toast(str);
				clearTimeout(this.tmr);
				this.tmr = setTimeout(function () {
					str = '';
					self.tmr = null;
					self.props.history.push("/client-session/" + link);
				}, 2500);
			}
		}
	}
	onClose = () => {
		const {
			outAppointment,
		} = this.props;
		const data = {
			auth_id: localStorage.client_id,
			id: this.props.match.params && this.props.match.params.id,
			client_id: localStorage.client_id,
			role: "client",
		};
		if (outAppointment) {
			outAppointment(data);
			//this.props.history.push("/client-session/" + this.props.match.params.id);
			this.props.history.push("/dashboard");
		}
	};

	render() {
		return (
			<>
				<ToastContainer/>
				<div className="flex-space bg-position">
					<iframe
						id={"video-frame"}
						className="video-frame"
						title='tele-therapy video room'
						allow={'camera; microphone; display-capture'}
						//src={`${config.WEBRTC_HOST}/TeleTherapistVideoRoom-${this.props.match.params.id}#interfaceConfig.langDetection=true&config.defaultLanguage=%22en%22&userInfo.email=%22${localStorage.client_email}%22&userInfo.displayName=%22${localStorage.client_name}%22`}
						src={`${config.WEBRTC_HOST}/TeleTherapistVideoRoom-${this.props.match.params.id}#interfaceConfig.langDetection=true&config.defaultLanguage=%22es%22&config.prejoinPageEnabled=false&userInfo.email=%22${localStorage.client_email}%22&userInfo.displayName=%22${localStorage.client_name}%22`}
						allowFullScreen={true}
					/>
				</div>
				<div className="btn-on-off" onClick={this.onClose} />
			</>
		)
	}
}
const mapStateToProps = (state) => {
	return {
		msg_join: state.registers.msg_join,
		msg_join_err: state.registers.msg_join_err,
		msg_event: state.registers.msg_event,
	}
};

export default connect(
	mapStateToProps,
	{
		outAppointment,
		joinAppointment,
		reset,
	}
)(ClientVideoSession);
